import React from 'react'
import Loadable from 'react-loadable'
// import jwt from 'jsonwebtoken'

const style = {
    minHeight:'50rem'
}

function Loading() {
    return (<div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>)
}

const Home = Loadable({
    loader: () => import('./views/Home'),
    loading: Loading,
})

const Dashboard = Loadable({
    loader: () => import('./views/Dashboard'),
    loading: Loading,
})

const PetaStatus = Loadable({
    loader: () => import('./views/Dashboard/PetaStatus'),
    loading: Loading,
})

const InputAsesment = Loadable({
    loader: () => import('./views/InputAsesment'),
    loading: Loading,
})

const DetailPerusahaan = Loadable({
    loader: () => import('./views/DetailPerusahaan'),
    loading: Loading,
})

const DataAsesment = Loadable({
    loader: () => import('./views/DataAsesment'),
    loading: Loading,
})

const Logs = Loadable({
    loader: () => import('./views/Logs'),
    loading: Loading
})

const FormExecutiveSummary = Loadable({
    loader: () => import('./views/FormExecutiveSummary'),
    loading: Loading,
})


const Profile = Loadable({
    loader: () => import('./views/Profile'),
    loading: Loading,
})

const MasterData = Loadable({
    loader: () => import('./views/MasterData'),
    loading: Loading,
})

const MasterPerusahaan = Loadable({
    loader: () => import('./views/MasterData/MasterPerusahaan'),
    loading: Loading,
})
const MasterPerusahaanAsessor = Loadable({
    loader: () => import('./views/MasterData/MasterPerusahaanAsessor'),
    loading: Loading,
})
const MasterSheet = Loadable({
    loader: () => import('./views/MasterData/MasterSheet'),
    loading: Loading,
})
const MasterJenisPerusahaan = Loadable({
    loader: () => import('./views/MasterData/MasterJenisPerusahaan'),
    loading: Loading,
})
const MasterJenisSheet = Loadable({
    loader: () => import('./views/MasterData/MasterJenisSheet'),
    loading: Loading,
})
const MasterUser = Loadable({
    loader: () => import('./views/MasterData/MasterUser'),
    loading: Loading,
})
const MasterUserPerusahaan2 = Loadable({
    loader: () => import('./views/MasterData/MasterUserPerusahaan'),
    loading: Loading,
})
const MasterTahun = Loadable({
    loader: () => import('./views/MasterData/MasterTahun'),
    loading: Loading,
})

const FormPenilaian = Loadable({
    loader: () => import('./views/FormPenilaian'),
    loading: Loading,
})

const LihatAsesment = Loadable({
    loader: () => import('./views/LihatAsesment'),
    loading: Loading,
})

const FormSheet = Loadable({
    loader: () => import('./views/MasterData/FormSheet'),
    loading: Loading,
})

const FormTemuan = Loadable({
    loader: () => import('./views/FormTemuan'),
    loading: Loading,
})

const ChangeRole = Loadable({
    loader: () => import('./views/ChangeRole'),
    loading: Loading,
})

const MasterParentPerusahaan = Loadable({
    loader: () => import('./views/MasterData/MasterParentPerusahaan'),
    loading: Loading,
})

const LogApp = Loadable({
    loader: () => import('./views/LogApp'),
    loading: Loading,
})

const LogAppDetail = Loadable({
    loader: () => import('./views/LogApp/[id]'),
    loading: Loading,
})

const routes = [
    {path: '/home', exact: true, name: 'Home', component: (props) => (
        <Home {...props} />
    )},
    {path: '/profile', exact: true, name: 'Profile', component: (props) => (
        <Profile {...props} />
    )},
    {path: '/dashboard', exact: true, name: 'Dashboard AGC', component: (props) => (
        <Dashboard {...props} />
    )},
    {path: '/dashboard/peta-status', exact: true, name: 'Peta Status', component: (props) => (
        <PetaStatus {...props} />
    )},
    {path: '/input-asesment', exact: true, name: 'Input Assessment AGC', component: (props) => (
        <InputAsesment {...props} />
    )},
    {path: '/input-asesment/:id', exact: true, name: 'Detail Perusahaan', component: (props) => (
        <DetailPerusahaan {...props} />
    )},
    {path: '/input-asesment/:id/sheet/:sheetId/:masterJenisPerusahaanId', exact: true, name: 'Penilaian', component: (props) => (
        <FormPenilaian {...props} />
    )},
    {path: '/input-asesment/:id/executive-summary/:masterJenisPerusahaanId', exact: true, name: 'Executive Summary', component: (props) => (
        <FormExecutiveSummary {...props} />
    )},
    {path: '/input-asesment/:id/form-temuan', exact: true, name: 'Form Temuan', component: (props) => (
        <FormTemuan {...props} />
    )
    },
    {path: '/input-asesment/:id/:tahun/form-temuan', exact: true, name: 'Form Temuan', component: (props) => (
        <FormTemuan {...props} />
    )},
    {path: '/data-asesment', exact: true, name: 'Data Assessment', component: (props) => (
        <DataAsesment {...props} tahun="2018" />
    )},
    {path: '/data-asesment/:id/logs', exact: true, name: 'Log Perusahaan', component: (props) => (
        <Logs {...props} />
    )},
    {path: '/data-asesment/:id/:tahun', exact: true, name: 'Detail Perusahaan', component: (props) => (
        <DetailPerusahaan {...props} />
    )},
    {path: '/data-asesment/:id/:tahun/sheet/:sheetId', exact: true, name: 'Detail Sheet', component: (props) => (
        <FormPenilaian {...props} />
    )},
    {path: '/data-asesment/:id/:tahun/executive-summary', exact: true, name: 'Executive Summary', component: (props) => (
        <FormExecutiveSummary {...props} />
    )},
    {path: '/data-asesment/:id/:tahun/form-temuan', exact: true, name: 'Form Temuan', component: (props) => (
        <FormTemuan {...props} />
    )},
    {path: '/master-data', exact: true, name: 'Master Data', component: (props) => (
        <MasterData {...props} />
    )},
    {path: '/master-perusahaan', exact: true, name: 'Master Instalasi', component: (props) => (
        <MasterPerusahaan {...props} />
    )
    },
    {path: '/master-parent-perusahaan', exact: true, name: 'Master Perusahaan', component: (props) => (
        <MasterParentPerusahaan {...props} />
    )},
    {path: '/master-perusahaan/:id/asessor', exact: true, name: 'Master Perusahaan', component: (props) => (
        <MasterPerusahaanAsessor {...props} />
    )},
    {path: '/master-sheet', exact: true, name: 'Master Sheet', component: (props) => (
        <MasterSheet {...props} />
    )},
    {path: '/master-jenis-kriteria', exact: true, name: 'Master Jenis Kriteria', component: (props) => (
        <MasterJenisPerusahaan {...props} />
    )},
    {path: '/master-jenis-kriteria/:id/sheet', exact: true, name: 'Sheet', component: (props) => (
        <MasterJenisSheet {...props} />
    )},
    {path: '/master-jenis-kriteria/:id/sheet/:sheetPerusahaanId', exact: true, name: 'Detail Sheet', component: (props) => (
        <FormSheet {...props} />
    )},
    {path: '/master-user', exact: true, name: 'Master User', component: (props) => (
        <MasterUser {...props} />
    )},
    {path: '/master-user/:id/perusahaan', exact: true, name: 'Perusahaan', component: (props) => (
        <MasterUserPerusahaan2 {...props} />
    )},
    {path: '/master-tahun', exact: true, name: 'Setting Tahun Aktif', component: (props) => (
        <MasterTahun {...props} />
    )},
    {path: '/lihat-asesment', exact: true, name: 'Lihat Asesment', component: (props) => (
        <LihatAsesment {...props} />
    )},
    {path: '/lihat-asesment/:id/:tahun', exact: true, name: 'Detail Perusahaan', component: (props) => (
        <DetailPerusahaan {...props} />
    )},
    {path: '/lihat-asesment/:id/:tahun/sheet/:sheetId', exact: true, name: 'Detail Perusahaan', component: (props) => (
        <FormPenilaian {...props} />
    )},
    {path: '/lihat-asesment/:id/:tahun/executive-summary', exact: true, name: 'Executive Summary', component: (props) => (
        <FormExecutiveSummary {...props} />
    )},
    {path: '/lihat-asesment/:id/:tahun/form-temuan', exact: true, name: 'Form Temuan', component: (props) => (
        <FormTemuan {...props} />
    )},
    {path: '/change-role', exact: true, name: 'Change Role', component: (props) => (
        <ChangeRole {...props} />
    )},
    {path: '/logs', exact: true, name: 'Logs', component: (props) => (
        <LogApp {...props} />
    )},
    {path: '/logs/:id', exact: true, name: 'Logs Detail', component: (props) => (
        <LogAppDetail {...props} />
    )}
]

export default routes;